import { CssBaseline, StyledEngineProvider } from "@mui/material";
import "./App.css";
import AdminRouter from "./Router/AdminRouter";
import AuthRouter from "./Router/AuthRouter";
import ThemeProvider from "./Theme/ThemeProvider";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

  return (
    <StyledEngineProvider>
      <ThemeProvider>
        <CssBaseline />
        {location.pathname.includes("/auth") ? <AuthRouter /> : <AdminRouter />}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
